/**
 * @fileoverview POST handler for the "/alloys/shopify/:app_group_id/bridges/:bridge_id/catalog_item_errors_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { alloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExportCacheKeys } from "./constants";
import type {
  PostAlloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExportProps,
  AlloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExportResult,
} from "./types";

export const postAlloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExport = reactQueryMutationAdapter(
  alloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExportCacheKeys,
  (
    props: PostAlloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExportProps
  ): Promise<AlloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExportResult> => {
    return fetch(
      `/alloys/shopify/${props.appGroupId}/bridges/${props.bridgeId}/catalog_item_errors_export`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
